import "./FormField.scss";
import { Form } from 'react-bootstrap';

const FormCheckbox = (props) => {
  const { label, optionList, value, setFunc, showLabel, checked, item, disabled } = props;

  return (
      <>
        <Form.Group className="mb-3" controlId="formBasicPassword">
          {showLabel && (<Form.Label>{label}</Form.Label>)}
          {/* <Form.Select 
            value={value}
            onChange={(event) => setFunc(event.target.value)}
          >
            <option value="">Select {label}</option>
            {optionList && optionList.map((item, index) => {
              return (
                <option key={item.id} value={item.name}>{item.label}</option>
              );
            })}
          </Form.Select> */}
          <Form.Check 
            type="checkbox" 
            label={label}
            value={value}
            checked={checked}
            onChange={(event) => setFunc(event.target.value, item)}
            disabled={disabled}
          />
        </Form.Group>
      </>
  );
};

export default FormCheckbox;
